import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useAccountingCustomers } from '~/hooks/reactQuery/queries/useAccountingCustomers';
import { OptionType } from '~/integrations/Accounting/AccountingCustomerDropdown/AccountingCustomerDropdown.utils';
import { selectors } from '~/store/state-selectors';
import { useStore } from '~/store/store-context';
import { Accounting } from '~/types/api.model';
import { CONTACT_FIELD_NAME } from '../EditContactModal.utils';
export function useEditContactAccountingPrefill(contact) {
    const { setValue } = useFormContext();
    const isLinkedToQbo = useStore(selectors.integration.isLinkedToQbo);
    const isLinkedToXero = useStore(selectors.integration.isLinkedToXero);
    const { customers: qboCustomers } = useAccountingCustomers(Accounting.QBO, {
        enabled: isLinkedToQbo
    });
    const { customers: xeroCustomers } = useAccountingCustomers(Accounting.Xero, {
        enabled: isLinkedToXero
    });
    const qboIntegratedId = contact.integratedId({
        accounting: Accounting.QBO
    });
    const xeroIntegratedId = contact.integratedId({
        accounting: Accounting.Xero
    });
    const qboMatched = qboIntegratedId != null ? qboCustomers.find((c)=>c.id() === qboIntegratedId) : undefined;
    const xeroMatched = xeroIntegratedId != null ? xeroCustomers.find((c)=>c.id() === xeroIntegratedId) : undefined;
    useEffect(()=>{
        if (qboMatched) setValue("".concat(CONTACT_FIELD_NAME, ".qbo"), {
            type: OptionType.Existing,
            customer: qboMatched
        });
    }, [
        qboMatched,
        setValue
    ]);
    useEffect(()=>{
        if (xeroMatched) setValue("".concat(CONTACT_FIELD_NAME, ".xero"), {
            type: OptionType.Existing,
            customer: xeroMatched
        });
    }, [
        xeroMatched,
        setValue
    ]);
    return {
        qbo: qboMatched === null || qboMatched === void 0 ? void 0 : qboMatched.id(),
        xero: xeroMatched === null || xeroMatched === void 0 ? void 0 : xeroMatched.id()
    };
}
